<template>
  <div
    class="aca-school-page-skeleton"
    aria-busy="true"
    aria-live="polite">
    <section class="aca-school-page-skeleton__hero hero-banner">
      <div class="aca-school-page-skeleton__hero-image">
        <PrePeersSkeleton variant="block" />
      </div>
      <div class="hero-banner__logo aca-school-page-skeleton__logo">
        <PrePeersSkeleton variant="block" />
      </div>
    </section>

    <section class="hero-section">
      <div class="container aca-school-page-skeleton__hero-text">
        <PrePeersSkeleton
          variant="text"
          height="2.25rem"
          width="min(480px, 90%)" />
        <PrePeersSkeleton
          variant="text"
          height="1.25rem"
          width="min(320px, 70%)" />
        <PrePeersSkeleton
          variant="text"
          width="100%" />
        <PrePeersSkeleton
          variant="text"
          width="92%" />
        <PrePeersSkeleton
          variant="text"
          width="68%" />
        <PrePeersSkeleton
          variant="text"
          width="120px"
          height="2px" />
      </div>
    </section>

    <section
      v-if="showMapSection"
      class="aca-school-page-skeleton__map">
      <div class="container">
        <PrePeersSkeleton
          variant="text"
          height="1.5rem"
          width="min(280px, 60%)" />
        <div class="aca-school-page-skeleton__map-grid">
          <PrePeersSkeleton
            v-for="i in 3"
            :key="i"
            variant="block"
            height="180px" />
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import PrePeersSkeleton from '~/components/ui/PrePeersSkeleton.vue'

withDefaults(
  defineProps<{
    /** Placeholder carte + cartes (page liste programmes). */
    showMapSection?: boolean
  }>(),
  {
    showMapSection: false,
  },
)
</script>

<style scoped>
.aca-school-page-skeleton__hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 280px;
  margin-bottom: 70px;
  overflow: visible;
  background-color: var(--bg-surface);
}

.aca-school-page-skeleton__hero-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: clamp(300px, 70vw, 800px);
  height: 220px;
  max-height: 260px;
  transform: translate(-50%, -50%);
  border-radius: var(--radius-lg);
  overflow: hidden;
  z-index: 1;
}

.aca-school-page-skeleton__hero-image :deep(.prepeers-skeleton) {
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.aca-school-page-skeleton__logo {
  pointer-events: none;
}

.aca-school-page-skeleton__hero-text {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.aca-school-page-skeleton__map {
  padding: var(--space-8) 0 var(--space-12);
}

.aca-school-page-skeleton__map-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: var(--space-6);
  margin-top: var(--space-6);
}
</style>
